<template>
  <div>
    <b-row>
      <b-col cols="12">
        <b-card class="mb-3" title="Yeni İçerik Ekle">
          <b-alert variant="warning" show class="mb-0">
            <div class="alert-body mb-2">
              <span
                ><strong>Not:</strong> Eklenecek içerik adı ve arama motoru bağlantı linki
                benzersiz olmalıdır...</span
              >
            </div>
          </b-alert>
          <b-button
            class="float-right"
            v-ripple.400="'rgba(255, 255, 255, 0.15)'"
            variant="primary"
            to="/contents/categories"
          >
            Kategori Listesi
          </b-button>
        </b-card>
      </b-col>
    </b-row>
    <validation-observer ref="rules">
      <b-row>
        <b-col cols="12">
          <b-card class="mb-3" title="İçerik Ekleme Formu">
            <b-row>
              <b-col>
                <b-form-group label="İçerik Tipi" label-for="contentType">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: true,
                    }"
                    name="İçerik Titpi"
                  >
                    <v-select
                      id="contentType"
                      v-model="selectedContentType"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="contentTypes"
                      :disabled="categoryTypeIsEducation"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Kategoriler" label-for="categories">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: true,
                    }"
                    name="Kategoriler"
                  >
                    <v-select
                      id="educators"
                      v-model="selectedCategory"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="categories"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row :style="isPersonsHide ? 'display:none;' : 'display:block;'">
              <b-col md="12">
                <b-form-group
                  :label="
                    personType == 'writer'
                      ? 'Yazarlar (Yok ise boş bırakın)'
                      : 'Eğitmenler (Yok ise boş bırakın)'
                  "
                  label-for="educators"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: false,
                    }"
                    :name="personType == 'writer' ? 'Yazarlar' : 'Eğitmenler'"
                  >
                    <v-select
                      id="educators"
                      v-model="selectedEducators"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="fullName"
                      multiple
                      :options="educators"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="İlişkili İçerikler (opsiyonel)" label-for="contents">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: false,
                    }"
                    name="İçerikler"
                  >
                    <v-select
                      id="contents"
                      v-model="selectedContents"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      label="title"
                      multiple
                      :options="contents"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12">
                <b-form-group label="Başlık" label-for="title">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Başlık"
                  >
                    <b-form-input
                      id="title"
                      v-model="title"
                      placeholder="Başlık"
                      :state="errors.length > 0 ? false : null"
                      :class="title.length >= chars.title ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="title.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ title.length }}</span>
                      /
                      {{ chars.title }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Başlığı" label-for="linktTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Bağlantı Başlığı"
                  >
                    <b-form-input
                      id="linkTitle"
                      v-model="linkTitle"
                      placeholder="Bağlantı Başlığı"
                      :state="errors.length > 0 ? false : null"
                      :class="linkTitle.length >= chars.linkTitle ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="linkTitle.length >= chars.linkTitle ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ linkTitle.length }}</span>
                      /
                      {{ chars.linkTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row
              v-if="!isEditorHide"
              :style="categoryTypeIsEducation ? 'display:flex;' : 'display:none;'"
            >
              <b-col md="12">
                <b-form-group label="Kısa Açıklama" label-for="description">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: categoryTypeIsEducation ? true : false,
                      min: 30,
                    }"
                    name="Kısa Açıklama"
                  >
                    <b-form-textarea
                      id="description"
                      v-model="description"
                      placeholder="Kısa Açıklama"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        description.length >= chars.description ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="description.length >= chars.description ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ description.length }}</span>
                      /
                      {{ chars.description }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row :style="isEditorHide ? 'display:none' : 'display:block'">
              <b-col md="12">
                <b-form-group label="İçerik" label-for="text">
                  <editor v-if="isLoaded" id="text" :text="text" ref="refEditor"></editor>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row :style="isEditorHide ? 'display:block' : 'display:none'">
              <b-col md="12">
                <b-form-group
                  :label="slug == 'iletisim' ? 'S.S.S' : '101 Liste İçerik'"
                  label-for="text"
                >
                  <div>
                    <b-form
                      ref="form"
                      class="repeater-form mb-5"
                      @submit.prevent="repeateAgain"
                    >
                      <!--  Loop -->
                      <div
                        v-for="(contentItem, index) in contentItems"
                        :id="contentItems[index].id"
                        :key="contentItems[index].id"
                        ref="row"
                      >
                        <b-row>
                          <hr />
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Başlık" label-for="title">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: isEditorHide }"
                                name="Başlık"
                              >
                                <b-form-input
                                  v-model="contentItems[index].title"
                                  placeholder="Başlık"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    title.length >= chars.title ? 'text-danger' : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="title.length >= chars.title ? 'bg-danger' : ''"
                                >
                                  <span class="char-count">{{ title.length }}</span>
                                  /
                                  {{ chars.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                            <b-form-group label="Metin" :label-for="`text-${index}`">
                              <EditorLoop
                                :id="`text-${index}`"
                                :ref="`text-${index}`"
                                :text="contentItems[index].text.block"
                              ></EditorLoop>
                            </b-form-group>
                            <b-form-group
                              v-if="slug != 'iletisim'"
                              label="Podcast Linki"
                              label-for="title"
                            >
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: isEditorHide }"
                                name="Podcast Linki"
                              >
                                <b-form-input
                                  v-model="contentItems[index].podcastLink"
                                  placeholder="Podcast Linki"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    title.length >= chars.title ? 'text-danger' : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="title.length >= chars.title ? 'bg-danger' : ''"
                                >
                                  <span class="char-count">{{ title.length }}</span>
                                  /
                                  {{ chars.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                            <b-form-group
                              v-if="slug != 'iletisim'"
                              label="İçerik Linki"
                              label-for="title"
                            >
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: false }"
                                name="İçerik Linki"
                              >
                                <b-form-input
                                  v-model="contentItems[index].contentLink"
                                  placeholder="İçerik Linki"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    title.length >= chars.title ? 'text-danger' : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="title.length >= chars.title ? 'bg-danger' : ''"
                                >
                                  <span class="char-count">{{ title.length }}</span>
                                  /
                                  {{ chars.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Remove Button -->
                          <b-col lg="2" md="3" class="mb-50">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="mt-0 mt-md-2"
                              @click="removeItem(index)"
                            >
                              <feather-icon icon="XIcon" class="mr-25" />
                              <span>Sil</span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <hr />
                        </b-row>
                      </div>
                    </b-form>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgain"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Ekle</span>
                  </b-button>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="8">
                <DragDropImage
                  ref="refCardImage"
                  title="Kart Görseli"
                  :imageUrl="null"
                  :required="true"
                >
                </DragDropImage>
              </b-col>
              <b-col md="4">
                <b-form-group label="Görsel Başlığı (title)" label-for="imageTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Görsel Başlığı (title)"
                  >
                    <b-form-textarea
                      id="imageTitle"
                      v-model="imageTitle"
                      placeholder="Görsel Başlığı (title)"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="imageTitle.length >= chars.imageTitle ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="imageTitle.length >= chars.imageTitle ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ imageTitle.length }}</span>
                      /
                      {{ chars.imageTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
                <b-form-group
                  label="Görsel Açıklaması (alt text)"
                  label-for="imageAltText"
                >
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Görsel Açıklaması (alt text)"
                  >
                    <b-form-textarea
                      id="imageAltText"
                      v-model="imageAltText"
                      placeholder="Görsel Açıklaması (alt text)"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        imageAltText.length >= chars.imageAltText ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        imageAltText.length >= chars.imageAltText ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ imageAltText.length }}</span>
                      /
                      {{ chars.imageAltText }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-checkbox
                  class="mb-2"
                  v-model="isHeroHide"
                  checked="false"
                  switch
                  inline
                >
                  Kart Görselini Gizle
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Bağlantı Linki" label-for="slug">
                  <validation-provider
                    #default="{ errors }"
                    rules="required"
                    name="Bağlantı Linki"
                  >
                    <b-form-input
                      id="slug"
                      v-model="slug"
                      placeholder="Bağlantı Linki"
                      :state="errors.length > 0 || availability == false ? false : null"
                      :class="
                        slug.length >= chars.slug || availability == false
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="slug.length >= chars.slug ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ slug.length }}</span>
                      /
                      {{ chars.slug }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                  <div v-if="availability == false">
                    <p class="text-danger">
                      <small>İçerik linki benzersiz olmalıdır.</small>
                    </p>
                  </div>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Canonical Link" label-for="canonicalUrl">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: false }"
                    name="Canonical Link"
                  >
                    <b-form-input
                      id="slug"
                      v-model="canonicalUrl"
                      placeholder="Canonical Link"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        canonicalUrl.length >= chars.canonicalUrl ? 'text-danger' : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        canonicalUrl.length >= chars.canonicalUrl ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ canonicalUrl.length }}</span>
                      /
                      {{ chars.canonicalUrl }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col>
                <b-form-group label="Meta Başlığı" label-for="metaTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true }"
                    name="Meta Başlığı"
                  >
                    <b-form-input
                      id="metaTitle"
                      v-model="metaTitle"
                      placeholder="Meta Başlığı"
                      :state="errors.length > 0 ? false : null"
                      :class="metaTitle.length >= chars.metaTitle ? 'text-danger' : ''"
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="metaTitle.length >= chars.metaTitle ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ metaTitle.length }}</span>
                      /
                      {{ chars.metaTitle }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12">
                <b-form-group label="Meta Açıklaması" label-for="metaTitle">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: true, min: 30 }"
                    name="Meta Açıklaması"
                  >
                    <b-form-textarea
                      id="metaTitle"
                      v-model="metaDescription"
                      placeholder="Meta Açıklaması"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        metaDescription.length >= chars.metaDescription
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        metaDescription.length >= chars.metaDescription ? 'bg-danger' : ''
                      "
                    >
                      <span class="char-count">{{ metaDescription.length }}</span>
                      /
                      {{ chars.metaDescription }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="12" class="mb-2">
                <b-form-checkbox v-model="relatedContent" checked="true" switch inline>
                  İlişkili İçeriğe İzin Ver
                </b-form-checkbox>
              </b-col>
            </b-row>
            <b-row :style="categoryTypeIsEducation ? 'display:flex;' : 'display:none;'">
              <b-col cols="12">
                <h4>Eğitim Bilgileri</h4>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Programın Amacı ?" label-for="purpose">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: categoryTypeIsEducation,
                      min: 0,
                    }"
                    name="Programın Amacı ?"
                  >
                    <b-form-textarea
                      id="purpose"
                      v-model="education.purpose"
                      placeholder="Programın Amacı"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        education.purpose.length >= chars.education.purpose
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        education.purpose.length >= chars.education.purpose
                          ? 'bg-danger'
                          : ''
                      "
                    >
                      <span class="char-count">{{ education.purpose.length }}</span>
                      /
                      {{ chars.education.purpose }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Kimler Katılabilir ?" label-for="whoJoin">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: categoryTypeIsEducation,
                      min: 0,
                    }"
                    name="Kimler Katılabilir ?"
                  >
                    <b-form-textarea
                      id="whoJoin"
                      v-model="education.whoJoin"
                      placeholder="Kimler Katılabilir ?"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        education.whoJoin.length >= chars.education.whoJoin
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        education.whoJoin.length >= chars.education.whoJoin
                          ? 'bg-danger'
                          : ''
                      "
                    >
                      <span class="char-count">{{ education.whoJoin.length }}</span>
                      /
                      {{ chars.education.whoJoin }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col cols="12">
                <b-form-group label="Ön Koşullar" label-for="whoJoin">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: categoryTypeIsEducation,
                      min: 0,
                    }"
                    name="Ön Koşullar"
                  >
                    <b-form-textarea
                      id="whoJoin"
                      v-model="education.prerequisites"
                      placeholder="Ön Koşullar"
                      rows="3"
                      class="char-textarea"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        education.prerequisites.length >= chars.education.prerequisites
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="
                        education.prerequisites.length >= chars.education.prerequisites
                          ? 'bg-danger'
                          : ''
                      "
                    >
                      <span class="char-count">{{ education.prerequisites.length }}</span>
                      /
                      {{ chars.education.prerequisites }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Diller" label-for="languages">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{
                      required: categoryTypeIsEducation,
                    }"
                    name="Diller"
                  >
                    <v-select
                      id="languages"
                      v-model="education.selectedLanguage"
                      label="name"
                      :dir="$store.state.appConfig.isRTL ? 'rtl' : 'ltr'"
                      :options="languages"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Kontejyan" label-for="quota">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: categoryTypeIsEducation }"
                    name="Kontejyan"
                  >
                    <b-form-input
                      id="title"
                      v-model="education.quota"
                      placeholder="Kontejyan"
                      type="number"
                      :state="errors.length > 0 ? false : null"
                      :class="
                        education.quota.length >= chars.education.quota
                          ? 'text-danger'
                          : ''
                      "
                    />
                    <small
                      class="textarea-counter-value float-right"
                      :class="education.quota.length >= chars.title ? 'bg-danger' : ''"
                    >
                      <span class="char-count">{{ education.quota.length }}</span>
                      /
                      {{ chars.education.quota }}
                    </small>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col md="12">
                <b-form-group label="Sıkça Sorulan Sorular" label-for="text">
                  <div>
                    <b-form
                      ref="form"
                      class="repeater-form mb-5"
                      @submit.prevent="repeateAgainFaq"
                    >
                      <!--  Loop -->
                      <div
                        v-for="(faqItem, index) in education.faqItems"
                        :id="education.faqItems[index].id"
                        :key="education.faqItems[index].id"
                        ref="row"
                      >
                        <b-row>
                          <hr />
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Başlık" label-for="title">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{ required: categoryTypeIsEducation }"
                                name="Başlık"
                              >
                                <b-form-input
                                  v-model="education.faqItems[index].title"
                                  placeholder="Başlık"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    title.length >= chars.title ? 'text-danger' : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="title.length >= chars.title ? 'bg-danger' : ''"
                                >
                                  <span class="char-count">{{ title.length }}</span>
                                  /
                                  {{ chars.title }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <b-col md="12">
                            <b-form-group label="Kısa Açıklama" label-for="description">
                              <validation-provider
                                #default="{ errors }"
                                :rules="{
                                  required: categoryTypeIsEducation ? true : false,
                                  min: 30,
                                }"
                                name="Kısa Açıklama"
                              >
                                <b-form-textarea
                                  id="description"
                                  v-model="education.faqItems[index].text"
                                  placeholder="Kısa Açıklama"
                                  rows="3"
                                  class="char-textarea"
                                  :state="errors.length > 0 ? false : null"
                                  :class="
                                    description.length >= chars.description
                                      ? 'text-danger'
                                      : ''
                                  "
                                />
                                <small
                                  class="textarea-counter-value float-right"
                                  :class="
                                    description.length >= chars.description
                                      ? 'bg-danger'
                                      : ''
                                  "
                                >
                                  <span class="char-count">{{ description.length }}</span>
                                  /
                                  {{ chars.description }}
                                </small>
                                <small class="text-danger">{{ errors[0] }}</small>
                              </validation-provider>
                            </b-form-group>
                          </b-col>
                        </b-row>
                        <b-row>
                          <!-- Remove Button -->
                          <b-col lg="2" md="3" class="mb-50">
                            <b-button
                              v-ripple.400="'rgba(234, 84, 85, 0.15)'"
                              variant="outline-danger"
                              class="mt-0 mt-md-2"
                              @click="removeItemFaq(index)"
                            >
                              <feather-icon icon="XIcon" class="mr-25" />
                              <span>Sil</span>
                            </b-button>
                          </b-col>
                        </b-row>
                        <b-row>
                          <hr />
                        </b-row>
                      </div>
                    </b-form>
                  </div>
                  <b-button
                    v-ripple.400="'rgba(255, 255, 255, 0.15)'"
                    variant="primary"
                    @click="repeateAgainFaq"
                  >
                    <feather-icon icon="PlusIcon" class="mr-25" />
                    <span>Ekle</span>
                  </b-button>
                </b-form-group>
              </b-col>
              <b-col md="2" class="mb-2">
                <b-form-group label="Bilet Durumu" label-for="ticketStatus">
                  <validation-provider
                    #default="{ errors }"
                    :rules="{ required: categoryTypeIsEducation }"
                    name="Bilet Linki (Yok ise boş bırakın)"
                  >
                    <b-form-checkbox
                      v-model="education.ticketStatus"
                      checked="true"
                      switch
                      inline
                    >
                      Bilet Tükendi
                    </b-form-checkbox>
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>
            <b-row>
              <b-col md="6" class="mt-5">
                <b-button
                  class="float-left mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-primary"
                  @click="postConfirmText(true, true)"
                  >Önizleme
                </b-button>
              </b-col>
              <b-col md="6" class="mt-5">
                <b-button
                  class="float-right mt-2"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-success"
                  @click="postConfirmText(false, false)"
                >
                  <b-spinner v-if="spinner === true && isDraft === false" small />
                  {{ spinner === true && isDraft === false ? "Yayınlanıyor" : "Yayınla" }}
                </b-button>
                <b-button
                  class="float-right mt-2 mr-1"
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  variant="outline-warning"
                  @click="postConfirmText(true, false)"
                >
                  <b-spinner v-if="spinner == true && isDraft == true" small />
                  {{
                    spinner == true && isDraft == true
                      ? "Taslağa Kaydediliyor"
                      : "Taslağa Kaydet"
                  }}
                </b-button>
              </b-col>
            </b-row>
          </b-card>
        </b-col>
      </b-row>
    </validation-observer>
  </div>
</template>
<script>
import DragDropImage from "../components/DragDropImage";
import Editor from "../components/Editor";
import EditorLoop from "../components/EditorLoop";
import vSelect from "vue-select";
import Ripple from "vue-ripple-directive";
import { heightTransition } from "@core/mixins/ui/transition";
import { ValidationProvider, ValidationObserver } from "vee-validate";
import {
  BImg,
  BRow,
  BCol,
  BTime,
  BCard,
  BCardText,
  BButton,
  BForm,
  BMedia,
  BAlert,
  BSpinner,
  BFormInput,
  BFormGroup,
  BInputGroup,
  BFormTextarea,
  BMediaAside,
  BMediaBody,
  BFormFile,
  BFormDatepicker,
  BFormCheckbox,
  BLink,
} from "bootstrap-vue";
import {
  required,
  email,
  confirmed,
  url,
  between,
  alpha,
  integer,
  password,
  min,
  digits,
  alphaDash,
  length,
} from "@validations";
import settings from "../../../settings";
import { Endpoints } from "@core/endpoints/endpoints";
const endpoints = new Endpoints();

export default {
  components: {
    DragDropImage,
    Editor,
    EditorLoop,
    BImg,
    BRow,
    BCol,
    BTime,
    BLink,
    BCard,
    BCardText,
    BButton,
    BForm,
    BSpinner,
    BAlert,
    BFormGroup,
    BFormInput,
    BInputGroup,
    BFormTextarea,
    BMedia,
    BMediaAside,
    BMediaBody,
    BFormFile,
    BFormDatepicker,
    BFormCheckbox,
    vSelect,
    ValidationProvider,
    ValidationObserver,
    required,
    email,
    confirmed,
    url,
    between,
    alpha,
    integer,
    password,
    min,
    digits,
    alphaDash,
    length,
  },
  directives: {
    Ripple,
  },
  mixins: [heightTransition],
  data() {
    return {
      slug: "",
      canonicalUrl: " ",
      text: {},
      title: "",
      isDraft: false,
      category: {},
      linkTitle: "",
      imageTitle: "",
      description: "",
      imageAltText: "",
      metaTitle: "",
      featuredImage: require("@/assets/images/placeholder/1920x1080.jpg"),
      metaDescription: "",
      selectedCategory: null,
      categorySlugParam: this.$route.params.slugParam,
      categoryTypeIsEducation: false,
      isPersonsHide: true,
      isEditorHide: false,
      personType: null,
      contents: [],
      languages: [],
      educators: [],
      categories: [],
      contentTypes: [],
      selectedContents: [],
      selectedEducators: [],
      selectedContentType: [],
      relatedContent: true,
      isHeroHide: false,
      availability: true,
      spinner: false,
      contentItems: [
        {
          id: 1,
          title: null,
          text: "",
          podcastLink: null,
          contentLink: null,
        },
      ],
      education: {
        quota: "0",
        purpose: "",
        whoJoin: "",
        prerequisites: "",
        selectedLanguage: [],
        faqItems: [
          {
            id: 1,
            title: null,
            text: null,
          },
        ],
      },
      chars: {
        slug: 255,
        title: 55,
        canonicalUrl: 1000,
        linkTitle: 55,
        imageTitle: 60,
        description: 200,
        imageAltText: 140,
        metaTitle: 65,
        metaDescription: 160,
        education: {
          quota: 5,
          purpose: 500,
          whoJoin: 500,
          prerequisites: 500,
          ticketStatus: true,
        },
      },
      isLoaded: false,
      nextTodoId: 2,
      nextTodoIdFaq: 2,
    };
  },
  watch: {
    title(newTitle, oldTitle) {
      this.slug = newTitle;
      this.linkTitle = newTitle;
      this.metaTitle = newTitle;
      this.imageTitle = newTitle;
      this.imageAltText = newTitle;

      if (this.selectedCategory.mainCategory == null) {
        this.metaDescription = `${newTitle}, ${this.selectedCategory.name} kategorisinde listeleniyor. ${newTitle} ile ilgili detaylı bilgi için tıklayın!`;
      } else {
        this.metaDescription = `${newTitle}, ${this.selectedCategory.name} ve ${this.selectedCategory.mainCategory.title}  kategorilerinde listeleniyor. ${newTitle} ile ilgili detaylı bilgi için tıklayın!`;
      }
    },
    slug(newSlug, oldSlug) {
      this.slug = this.slugify(newSlug);
      this.slugAvailability(this.slug);
    },
    selectedCategory(newCategory, oldCategory) {
      this.categorySlugParam = newCategory.slug;
      this.$router.replace({ path: `/contents/create/${newCategory.slug}` });
      newCategory.categoryType.type == "education"
        ? (this.categoryTypeIsEducation = true)
        : (this.categoryTypeIsEducation = false);

      switch (newCategory.categoryType.type) {
        case "education":
          this.getEducatorsType("educator");
          this.personType = "educator";
          this.isPersonsHide = false;
          this.selectedContentType = this.contentTypes[0];
          break;
        case "seminar":
          this.getEducatorsType("educator");
          this.personType = "educator";
          this.isPersonsHide = false;
          break;
        case "workshops":
          this.getEducatorsType("educator");
          this.personType = "educator";
          this.isPersonsHide = false;
          break;
        case "content":
          this.getEducatorsType("writer");
          this.personType = "writer";
          this.isPersonsHide = false;
          break;
        default:
          this.getEducatorsType("writer");
          this.personType = "writer";
          this.isPersonsHide = true;
      }
    },
    selectedContentType(newContentType, oldContentType) {
      if (newContentType.type == "101-list") {
        this.isEditorHide = true;
        this.isPersonsHide = true;
      } else {
        this.isEditorHide = false;
      }
    },
  },
  methods: {
    slugify(text, ampersand = "and") {
      const a = "àáäâèéëêıìíïîòóöôùúüûñçßÿỳýœæŕśşńṕẃǵğǹḿǘẍźḧ";
      const b = "aaaaeeeeiiiiioooouuuuncsyyyoarssnpwggnmuxzh";
      const p = new RegExp(a.split("").join("|"), "g");
      return text
        .toString()
        .toLowerCase()
        .replace(/[\s_]+/g, "-")
        .replace(p, (c) => b.charAt(a.indexOf(c)))
        .replace(/&/g, `-${ampersand}-`)
        .replace(/[^\w-]+/g, "")
        .replace(/--+/g, "-")
        .replace(/^-+|-+$/g, "");
    },
    slugAvailability(slug) {
      let formData = new FormData();
      formData.append("id", null);
      formData.append("slug", slug);
      endpoints
        .postContentsAvailability(formData, this.$i18n.locale, () => {})
        .then((data) => {
          this.availability = data.response.availability;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    repeateAgain() {
      this.contentItems.push({
        id: (this.nextTodoId += this.nextTodoId),
        title: null,
        text: "",
        podcastLink: null,
        contentLink: null,
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    repeateAgainFaq() {
      this.education.faqItems.push({
        id: (this.nextTodoIdFaq += this.nextTodoIdFaq),
        title: null,
        text: null,
      });
      this.$nextTick(() => {
        this.trAddHeight(this.$refs.row[0].offsetHeight);
      });
    },
    removeItem(index) {
      this.contentItems.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    removeItemFaq(index) {
      this.education.faqItems.splice(index, 1);
      this.trTrimHeight(this.$refs.row[0].offsetHeight);
    },
    initTrHeight() {
      this.trSetHeight(null);
      this.$nextTick(() => {
        this.trSetHeight(this.$refs.form.scrollHeight);
      });
    },
    onContext(ctx) {
      this.context = ctx;
    },
    getLanguages() {
      endpoints
        .getLanguages(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.languages = [];
          this.languages = [...data.response];
          this.education.selectedLanguage = this.languages[0];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getCategories() {
      endpoints
        .getCategories(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.categories = [];
          this.categories = [...data.response];
          this.selectedCategory = this.categories.find(
            (element) => element.slug === this.categorySlugParam
          );
          this.getContentsByCategorySlug(this.selectedCategory.slug);
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getContentTypes() {
      endpoints
        .getContentTypes(null, this.$i18n.locale, () => {})
        .then((data) => {
          this.contentTypes = [];
          this.contentTypes = [...data.response];
          this.selectedContentType = this.contentTypes[0];
          this.isLoaded = true;
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getEducatorsType(type) {
      endpoints
        .getEducatorsType(type, this.$i18n.locale, () => {})
        .then((data) => {
          this.educators = [];
          this.educators = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    getContentsByCategorySlug(slug) {
      endpoints
        .getContentsByCategorySlug(slug, this.$i18n.locale, () => {})
        .then((data) => {
          this.contents = [];
          this.contents = [...data.response];
        })
        .catch((err) => {
          console.log(err);
        });
    },
    postConfirmText(isDraft, preview) {
      this.isDraft = isDraft;
      this.$swal({
        title: "Kayıt?",
        text: "Yeni içeriği kaydetmek istediğinize emin misiniz?",
        icon: "warning",
        showCancelButton: true,
        cancelButtonText: "Vazgeç!",
        confirmButtonText: "Kaydet!",
        customClass: {
          confirmButton: "btn btn-primary",
          cancelButton: "btn btn-outline-danger ml-1",
        },
        buttonsStyling: false,
      }).then((result) => {
        if (result.value) {
          this.postSubmit(preview);
        }
      });
    },
    postSubmit(preview) {
      if (this.availability) {
        this.$refs.rules.validate().then((success) => {
          if (success) {
            this.spinner = true;
            let text = "";
            let contentIds = [];
            let educatorIds = [];
            let formData = new FormData();
            if (this.selectedContentType.type == "101-list") {
              for (let index = 0; index < this.contentItems.length; index++) {
                this.contentItems[index].text = this.$refs[`text-${index}`][0].eData;
              }
            }
            this.isEditorHide
              ? (text = JSON.stringify(this.contentItems))
              : (text = JSON.stringify(this.$refs.refEditor.value));
            formData.append("slug", this.slug);
            formData.append(
              "canonicalUrl",
              this.canonicalUrl.trim() == "" ? null : this.canonicalUrl
            );
            formData.append("text", text);
            formData.append("title", this.title);
            formData.append("image", this.$refs.refCardImage.image);
            formData.append("isDraft", this.isDraft);
            formData.append("isHeroHide", this.isHeroHide);
            formData.append("linkTitle", this.linkTitle);
            formData.append("imageTitle", this.imageTitle);
            formData.append("imageAltText", this.imageAltText);
            formData.append("metaTitle", this.metaTitle);
            formData.append("metaDescription", this.metaDescription);
            formData.append("categorySlug", this.selectedCategory.slug);
            formData.append("contentType", this.selectedContentType.type);
            formData.append("relatedContent", this.relatedContent);
            if (this.selectedContents.length > 0) {
              this.selectedContents.forEach((element) => {
                contentIds.push(element.id);
                formData.append("contentIds", JSON.stringify(contentIds));
              });
            } else {
              formData.append("contentIds", JSON.stringify([]));
            }
            if (this.isPersonsHide == false) {
              if (this.selectedEducators.length > 0) {
                this.selectedEducators.forEach((element) => {
                  educatorIds.push(element.id);
                  formData.append("educatorIds", JSON.stringify(educatorIds));
                });
              } else {
                formData.append("educatorIds", JSON.stringify([]));
              }
            } else {
              formData.append("educatorIds", JSON.stringify([]));
            }
            if (this.categoryTypeIsEducation) {
              formData.append("education", JSON.stringify(this.education));
              formData.append("description", this.description);
            }
            endpoints
              .postContents(formData, this.$i18n.locale, () => {})
              .then((data) => {
                this.spinner = false;
                if (data.status) {
                  if (preview == true) {
                    window.open(
                      `${settings.uiBaseUrl}/contents/preview/${this.slug}?hl=${this.$i18n.locale}`,
                      "_blank"
                    );
                  }
                  this.$swal({
                    icon: "success",
                    title: "Kayıt başarılı!",
                    text: "Yeni içerik eklendi.",
                    customClass: {
                      confirmButton: "btn btn-success",
                    },
                  }).then((result) => {
                    if (result.value) {
                      this.$router.push({
                        path: `/contents/categories/${this.categorySlugParam}`,
                      });
                    }
                  });
                }
              })
              .catch((err) => {
                this.spinner = false;
                console.log(err);
              });
          }
        });
      } else {
        this.$swal({
          title: "Hata!",
          text: "İçerik bağlantı linki benzersiz değil!",
          icon: "error",
          confirmButtonText: "Tamam",
          customClass: {
            confirmButton: "btn btn-primary",
          },
        }).then((result) => {
          if (result.value) {
          }
        });
      }
    },
  },
  created() {
    window.addEventListener("resize", this.initTrHeight);
  },
  destroyed() {
    window.removeEventListener("resize", this.initTrHeight);
  },
  mounted() {
    this.getLanguages();
    this.getCategories();
    this.getContentTypes();
    this.initTrHeight();
  },
  setup() {},
};
</script>

<style lang="scss">
@import "@core/scss/vue/libs/vue-select.scss";
</style>
